import { render, staticRenderFns } from "./MonoInstagramIcon.vue?vue&type=template&id=98e640f4&scoped=true"
import script from "./MonoInstagramIcon.vue?vue&type=script&lang=js"
export * from "./MonoInstagramIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98e640f4",
  null
  
)

export default component.exports